import React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';
import HeaderTitle from '../../Shared/HeaderTitle/HeaderTitle';
import { CustomTopToolbarActions } from '../../Shared/CustomTopToolbarActions';
import { ScheduledMessageForm } from '../components/ScheduledMessageForm';

const ScheduledMessageCreate: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (): void => {
    notify(`Scheduled message created successfully`);
    redirect('list', 'scheduledmessages');
  };

  return (
    <Create
      mutationOptions={{ onSuccess }}
      title={<HeaderTitle />}
      actions={<CustomTopToolbarActions title="Schedule a Message" />}
    >
      <ScheduledMessageForm />
    </Create>
  );
};

export default ScheduledMessageCreate;
